import types from './types';
import { sagas, actions } from './actions';
import reducer, { selectors } from './reducer';

export default reducer;

export {
    types as demoTypes,
    sagas as demoSagas,
    actions as demoActions,
    selectors as demoSelectors
};
